import { CardSubtitle as _CardSubtitle, CardSubtitleProps as _CardSubtitleProps } from "reactstrap";

    export const CardSubtitle = _CardSubtitle;
    export type CardSubtitleProps = _CardSubtitleProps;
    